/**
 * Shared constants for shift components
 */

// Time calculation constants
export const INTERVAL_MINUTES = 15; // 15-minute intervals
export const MINUTES_PER_HOUR = 60;
export const INTERVALS_PER_HOUR = MINUTES_PER_HOUR / INTERVAL_MINUTES; // 4 intervals per hour
export const HOURLY_SEGMENTS = 24; // 24 hours in a day

// Display constants
export const ROW_HEIGHT_PX = 64; // Corresponds to h-16 (16 * 4 = 64px)

// Width constants - CSS Grid handles sizing automatically

// Default time range
export const DEFAULT_BUSINESS_START_HOUR = 6; // 6 AM
export const DEFAULT_BUSINESS_END_HOUR = 23; // 11 PM

// Grid boundary constants for positioning validation
export const DAY_COLUMN_WIDTH_PX = 32; // Day column width when visible
export const MIN_GRID_COLUMN = 1; // Minimum valid grid column (1-indexed)
export const GAP_HEIGHT_PX = 8; // Gap between days in pixels

// Month divider constants for infinite scroll calendar
// Total height: pt-4 (16px) + visual area (32px) + pb-4 (16px) = 64px
export const MONTH_DIVIDER_HEIGHT_PX = 64;
// Visual height of the divider (excluding padding)
export const MONTH_DIVIDER_VISUAL_HEIGHT_PX = 32;
// Offset from top of divider area to the centered line (pt-4 + half visual = 16 + 16 = 32px)
export const MONTH_DIVIDER_LINE_OFFSET_PX = 32;